import { createTheme, Theme } from '@mui/material/styles';

import colors from './colors';
import componentStyleOverrides from './compStyleOverride';
import palette from './palette';
import typography from './typography';

/**
 * 주담 MUI Theme (Design Tokens 1.0)
 * radius 16 통일 · shadow low/high 매핑
 */
const buildShadows = (): Theme['shadows'] => {
  const low = colors.shadow.low;
  const high = colors.shadow.high;
  return [
    'none',
    low,
    low,
    low,
    low,
    low,
    low,
    low,
    high,
    high,
    high,
    high,
    high,
    high,
    high,
    high,
    high,
    high,
    high,
    high,
    high,
    high,
    high,
    high,
    high,
  ];
};

const theme = (): Theme => {
  const baseTheme = createTheme({
    palette,
    typography,
    spacing: 8, // MUI base unit 8px — design token scale (4,8,12…) is colors.spacing, not this
    shape: {
      borderRadius: colors.radius.card,
    },
    shadows: buildShadows(),
    breakpoints: {
      values: {
        xs: 0,
        sm: 768,
        md: 1024.5,
        lg: 1280,
        xl: 1920,
      },
    },
  });

  return createTheme(
    {
      ...baseTheme,
      components: {
        ...componentStyleOverrides(baseTheme),
        MuiToolbar: {
          styleOverrides: {
            root: {
              [`${baseTheme.breakpoints.up('xs')}`]: {
                minHeight: '56px',
                padding: '0 16px',
                '& .MuiTypography-h6': {
                  fontSize: '1.125rem',
                },
                '& .MuiIconButton-root': {
                  padding: '10px',
                },
              },
              [`${baseTheme.breakpoints.up('sm')}`]: {
                minHeight: '64px',
                padding: '0 24px',
                '& .MuiTypography-h6': {
                  fontSize: '1.25rem',
                },
                '& .MuiIconButton-root': {
                  padding: '12px',
                },
              },
              [`${baseTheme.breakpoints.up('md')}`]: {
                minHeight: '64px',
                padding: '0 32px',
              },
            },
            dense: {
              [`${baseTheme.breakpoints.up('xs')}`]: {
                minHeight: '56px',
              },
              [`${baseTheme.breakpoints.up('sm')}`]: {
                minHeight: '64px',
              },
            },
          },
        },
        MuiContainer: {
          styleOverrides: {
            root: {
              [`${baseTheme.breakpoints.up('xs')}`]: {
                maxWidth: '100%',
                paddingLeft: 16,
                paddingRight: 16,
              },
              [`${baseTheme.breakpoints.up('sm')}`]: {
                maxWidth: '720px',
                paddingLeft: 24,
                paddingRight: 24,
              },
              [`${baseTheme.breakpoints.up('md')}`]: {
                maxWidth: '960px',
                paddingLeft: 32,
                paddingRight: 32,
              },
              [`${baseTheme.breakpoints.up('lg')}`]: {
                maxWidth: '1280px',
              },
              [`${baseTheme.breakpoints.up('xl')}`]: {
                maxWidth: '1280px',
              },
            },
          },
        },
      },
      mixins: {
        toolbar: {
          minHeight: 64,
          paddingTop: 8,
          paddingBottom: 8,
        },
      },
    },
    baseTheme
  );
};

export default theme;
